import {Severity} from '@mojility/coach-core';

const SignupRequestController = function ($scope, $location, localize, eventsService, accountGateway) {
  const $ctrl = this;

  // onInit
  $ctrl.localize = localize;
  $ctrl.email = '';

  $ctrl.submit = function (email) {
    if (!$ctrl.submitIsDisabled()) {
      return accountGateway.requestAccountCreation(email)
        .then(() => {
          $scope.$applyAsync(() => {
            eventsService.publishSystemMessage($ctrl.localize.string('account_request', 'complete'));
            $location.path('/');
          });
        })
        .catch(error => {
          if (error.severity === Severity.ERROR) eventsService.publishSystemError(error.message); else eventsService.publishSystemMessage(error.message);
          $scope.$digest();
        });
    } else {
      return Promise.reject(eventsService.publishSystemError($ctrl.localize.string('account_request', 'invalid')));
    }
  };

  $ctrl.submitIsDisabled = function () {
    return !$ctrl.email || $ctrl.email.length == 0;
  };
};

export default {
  name: 'SignupRequestController',
  fn: SignupRequestController
};
